import axios from "axios";
import { ADD_PRODUCT, 
         GET_ALL_PRODUCT, 
         ADD_SUB_PRODUCT, 
         GET_ALL_SUB_PRODUCT, 
         GET_PRODUCT_RELATE_SUB_PRODUCTS, 
         CHANGE_PRODUCT_STATUS, 
         CHANGE_SUB_PRODUCT_STATUS, 
         GET_ACTIVE_PRODUCTS,
         GET_ALL_ACTIVE_PRODUCTS_OR_SUB_PRODUCTS,
         PRODUCT_RELATED_DETAILS,
         GET_SINGLE_PRODUCT_DETAILS,
         ADD_PRODUCT_CATEGORY,
        GET_PRODUCT_CATEGORY,
        ADD_PRODUCT_SUB_CATEGORY, 
        GET_PRODUCT_SUB_CATEGORY,
        ADD_PRODUCT_TYPE, 
        GET_PRODUCT_TYPE,
        ADD_PRODUCT_SERIES, 
        GET_PRODUCT_SERIES,
        ADD_PRODUCT_SUB_SERIES,
        GET_PRODUCT_SUB_SERIES
        } from "../config/urlConfig";
import { convertToFormData } from "../utils/commenController";
// <-----------------------------PRODUCT-------------------------------->
// Function for handling add product api
export async function handleAddProductApi(productData, token) {
  try {
    let formData = await convertToFormData(productData)
    
    let response = await axios.post(ADD_PRODUCT, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all product Or supporting product
export async function getAllProductOrSupportingProductApi(token, isMainProduct, page, itemsPerPage) {
  try {
    const params =  new URLSearchParams();
    params.append('isMainProduct',isMainProduct)
    params.append('page',page)
    params.append('limit', itemsPerPage)
    let response = await axios.get(`${GET_ALL_PRODUCT}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling change product status  api
export async function handleChangeProductStatusApi(productId, token) {
  try {

    let response = await axios.patch(`${CHANGE_PRODUCT_STATUS}/${productId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch single product details 
export async function fetchSingleProductDetailsApi(token, productId,isMainProduct, isEdit){
  try{
    
    let response = await axios.get(`${GET_SINGLE_PRODUCT_DETAILS}/${productId}?isMainProduct=${isMainProduct}&isEdit=${isEdit}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;

  }catch(error){
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
    
  }
}
// <-----------------------------SUB PRODUCT-------------------------------->
// Function for handling add product api
export async function handleAddSubProductApi(productData, token) {
  try {
    let formData = await convertToFormData(productData);
    
    let response = await axios.post(ADD_SUB_PRODUCT, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch all sub product
export async function getAllSubProductDetailsApi(token) {
  try {
    let response = await axios.get(GET_ALL_SUB_PRODUCT, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    console.log("response", response);

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for handling change sub product status  api
export async function handleChangeSubProductStatusApi(subProductId, token) {
  try {

    let response = await axios.patch(`${CHANGE_SUB_PRODUCT_STATUS}/${subProductId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}


// Function for fetch product relate sub product based on the product id
/* 
 * This api using in product module and quotation module
*/
export async function fetchProductRelateSubProductDetailsApi(token, productId, isQuotation, isMainProduct) {
  try {
    const params = new URLSearchParams();
    params.append('isQuotation',isQuotation)
    /* 
    * isMainProduct This params only need in product module view product
    */
    params.append('isMainProduct', isMainProduct)
    let response = await axios.get(`${GET_PRODUCT_RELATE_SUB_PRODUCTS}/${productId}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

export async function getProductRelateDetailsApi(token,  searchTerm, isQuotation) {
  try {
    
    const params = new URLSearchParams();
    params.append("searchText", searchTerm);
    params.append('isQuotation',isQuotation)

    let response = await axios.get(`${PRODUCT_RELATED_DETAILS}?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        // "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for fetch sub products
export async function getAllActiveSupportingOrProductsApi(token, isMainProductActive) {
  try {
    let response = await axios.get(`${GET_ALL_ACTIVE_PRODUCTS_OR_SUB_PRODUCTS}?isMainProductActive=${isMainProductActive}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// --------------------------------CATEGORY------------------------------------------

// Function for handling add category api
export async function handleAddCategoryApi(data, token) {
  try {
    
    let response = await axios.post(ADD_PRODUCT_CATEGORY, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for get product category
export async function fetchProductCategoryApi(token){
  try{
    const response = await axios.get(GET_PRODUCT_CATEGORY,{
      headers : {
        Authorization: `Bearer ${token}`,
        "Content-Type" : "application/json"
      }
    })
    return response.data
  }catch(error){
    if(error.response){
        return error.response.data
    }
  }
}

// --------------------------------SUB CATEGORY------------------------------------------

// Function for handling add category api
export async function handleAddSubCategoryApi(data, token) {
  try {
    
    let response = await axios.post(ADD_PRODUCT_SUB_CATEGORY, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for get product sub category
export async function fetchProductSubCategoryApi(token,mainCategoryId){
  try{
    const response = await axios.get(`${GET_PRODUCT_SUB_CATEGORY}/${mainCategoryId}`,{
      headers : {
        Authorization: `Bearer ${token}`,
        "Content-Type" : "application/json"
      }
    })
    return response.data
  }catch(error){
    if(error.response){
        return error.response.data
    }
  }
}

// --------------------------------PRODUCT TYPE------------------------------------------

// Function for handling add product type  api
export async function handleAddProductTypeApi(data, token) {
  try {
    
    let response = await axios.post(ADD_PRODUCT_TYPE, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for get product type
export async function fetchProductTypeApi(token, subCategoryId){
  try{
    const response = await axios.get(`${GET_PRODUCT_TYPE}/${subCategoryId}`,{
      headers : {
        Authorization: `Bearer ${token}`,
        "Content-Type" : "application/json"
      }
    })
    return response.data
  }catch(error){
    if(error.response){
        return error.response.data
    }
  }
}

// --------------------------------SERIES------------------------------------------

// Function for handling add series
export async function handleAddProductSeriesApi(data, token) {
  try {
    
    let response = await axios.post(ADD_PRODUCT_SERIES, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for get product series
export async function fetchProductSeriesApi(token,productTypeId){
  try{
    const response = await axios.get(`${GET_PRODUCT_SERIES}/${productTypeId}`,{
      headers : {
        Authorization: `Bearer ${token}`,
        "Content-Type" : "application/json"
      }
    })
    return response.data
  }catch(error){
    if(error.response){
        return error.response.data
    }
  }
}

// --------------------------------SUB SERIES------------------------------------------

// Function for handling add sub series api
export async function handleAddSubSeriesApi(data, token) {
  try {
    
    let response = await axios.post(ADD_PRODUCT_SUB_SERIES, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    if (error?.response) {
      console.log(error.response.data);

      return error.response.data;
    }
    console.log(error.message);
  }
}

// Function for get product sub category
export async function fetchProductSubSeriesApi(token,mainSeriesId){
  try{
    const response = await axios.get(`${GET_PRODUCT_SUB_SERIES}/${mainSeriesId}`,{
      headers : {
        Authorization: `Bearer ${token}`,
        "Content-Type" : "application/json"
      }
    })
    return response.data
  }catch(error){
    if(error.response){
        return error.response.data
    }
  }
}